export const sebraetecSituacaoNotaFiscalEnum = {
  APROVADO: 'APROVADO',
  REPROVADO: 'REPROVADO',
  PENDENTE: 'PENDENTE'
};
